import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import CustomState from './CustomState';
const NotFoundState = (props) => {
    const { icon = 'rioglyph-looking-glass-man' } = props, remainingProps = __rest(props, ["icon"]);
    return _jsx(CustomState, Object.assign({ icon: icon }, remainingProps));
};
export default NotFoundState;
